export default __webpack_public_path__ + "static/media/Subtract.1f007f90.svg";